module.exports = __webpack_public_path__ + "img/download.9ba4d979.svg";